import { combineReducers } from "redux";
import { reducer as reduxForm } from "redux-form";
import emailNotificationReducer from "./emailDeliverReducer";
import getCsrfToken from "./getCsrfToken";
import getServerDateTime from "./serverDateTimeReducer";

export default combineReducers({
  form: reduxForm,
  notification: emailNotificationReducer,
  getCsrf: getCsrfToken,
  getServerTime: getServerDateTime
});
